import { ca } from '@cian/analytics';

import { prerareQueryString } from '../../../../utils/prerareQueryString';

export function trackNavigateToSavedSearch(link?: string) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ListingSavedSearch',
    action: 'to_savesearch',
    page: {
      extra: {
        queryString: prerareQueryString(link),
      },
    },
  });
}

export function trackClickEditSavedSearch(link?: string) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ListingSavedSearch',
    action: 'click_edit',
    page: {
      extra: {
        queryString: prerareQueryString(link),
      },
    },
  });
}

export function trackEditSuccessSavedSearch(link?: string) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ListingSavedSearch',
    action: 'success_edit',
    page: {
      extra: {
        queryString: prerareQueryString(link),
      },
    },
  });
}

export function trackClickDeleteSavedSearch(link?: string) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'subscription',
    action: 'click_delete',
    label: 'saved_search',
    page: {
      extra: {
        queryString: prerareQueryString(link),
      },
    },
  });
}

export function trackDeleteSuccessSavedSearch(link?: string) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'subscription',
    action: 'delete_success',
    label: 'saved_search',
    page: {
      extra: {
        queryString: prerareQueryString(link),
      },
    },
  });
}
